import { useTranslation } from 'react-i18next'
import { Stack, Typography } from '@mui/material'

import { Label } from '@cibo/landmanager'
import { useProgram } from '@cibo/programs'
import { useAuth } from '@cibo/profile'

import { EnrollmentDetailsCellProps } from './EnrollmentListTypes'

export const EnrollmentDetailsCell = ({
  hideProgramLogo,
  hideProgramTitle,
  programId,
  programContent,
  ownedBy: { familyName, givenName, userPrimaryEmail, userId },
}: EnrollmentDetailsCellProps) => {
  const { data: program } = useProgram({ programId })
  const { t } = useTranslation('impact/components/EnrollmentList')
  const auth = useAuth()

  const programClosedLabel =
    program?.enrollmentWindow.enrollmentStatus === 'closed' ? (
      <Label color="error" size="small" label={t('closedProgram')} />
    ) : null
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {hideProgramLogo !== true && (
        <img
          style={{ height: '50px', width: '50px', objectFit: 'contain' }}
          src={`${programContent?.fields?.logo.fields.file.url}`}
          srcSet={`${programContent?.fields?.logo.fields.file.url}?w=50, ${programContent?.fields?.logo.fields.file.url}?w=100 2x, ${programContent?.fields?.logo.fields.file.url}?w=200 3x`}
          alt={programContent?.fields?.logo.fields.description}
          loading="lazy"
        />
      )}

      <Stack sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Typography
          variant="body2"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: userId === auth.userId ? 700 : undefined,
          }}
        >
          {!!givenName || !!familyName ? `${givenName} ${familyName}` : userPrimaryEmail}
        </Typography>
        {!hideProgramTitle ? (
          <Stack direction="row" spacing={1}>
            <Typography variant="caption" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {programContent?.fields?.title}
            </Typography>
            {programClosedLabel}
          </Stack>
        ) : (
          { programClosedLabel }
        )}
      </Stack>
    </Stack>
  )
}
